import React from "react";
import CBMaster from './CashBank_Master';

const CB_MasterApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Cash/Bank Master</h5>
          </div>
        </div>
        <CBMaster />
      </div>
    </div >
  );
};

export default CB_MasterApp;
